import { render, staticRenderFns } from "./RightColumnImageConfig.vue?vue&type=template&id=91b6d022&scoped=true&"
import script from "./RightColumnImageConfig.vue?vue&type=script&lang=js&"
export * from "./RightColumnImageConfig.vue?vue&type=script&lang=js&"
import style0 from "./RightColumnImageConfig.vue?vue&type=style&index=0&id=91b6d022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b6d022",
  null
  
)

export default component.exports